import http from "../../api";

export default {
  namespaced: true,
  actions: {
    getPartnerUsers({}, body) {
      return http.post("/partner/users", body);
    },
    getPartnerUsersCount({}) {
      return http.get("/partner/users/count");
    },
    validateUser({}, body) {
      return http.post("/partner/user/find", body);
    },
    confirmUser({}, body) {
      return http.post("/partner/user/confirm", body);
    },
    technicalReport({}, body) {
      return http.post("/partner/report/technical", body);
    },
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/partner.js